export const pravilnik_o_org_rada= {
    templateId: 221,
    category: 14,
    templateTitle: 'Pravilnik o organizaciji rada i sistematizaciji radnih mjesta',
    templateDescription: `<p>Poslodavac koji zapošljava najmanje dvadeset radnika dužan je urediti organizaciju rada i plaće, bilo kao sastavni dio Pravilnika o radu ili kroz poseban pravilnik.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Zakon o radu propisuje da je poslodavac koji zapošljava najmanje dvadeset radnika dužan donijeti i objaviti pravilnik o radu kojim se uređuju:</p>
    <p><strong>- plaće, organizacija rada,</strong><p>
    <p>- postupak i mjere za zaštitu dostojanstva radnika, </p>
    <p>- mjere zaštite od diskriminacije,</p>
    <p>- i druga pitanja važna za radnike zaposlene kod poslodavca,</p>
    <p>ako ta pitanja nisu uređena kolektivnim ugovorom.</p>
    <p>Dakle, Zakon o radu ne propisuje obvezu poslodavca da donese poseban pravilnik o organizaciji i sistematizaciji radnih mjesta, odnosno da donese interni akt kojim će urediti radna mjesta  (organizaciju rada) i plaće, a koja pitanja je dužan urediti, kao što je prethodno navedeno, poslodavac koji zapošljava 20 i više radnika.</p>
    <p>Ipak, radi jednostavnosti, navedene odredbe koje se odnose na plaće i organizaciju rada, predlaže se definirati posebnim pravilnikom o organizaciji rada i sistematizaciji radnih mjesta, a ne samim pravilnikom o radu, kojim se predlaže urediti preostala gore navedena područja pravilnika o radu.</p>
    <p>Naime, posebnim pravilnicima mogu  se uređivati određena područja za koja Zakona o radu određuje da se uređuju Pravilnikom o radu, pa se npr. može donijeti poseban pravilnik o organizaciji rada i sistematizaciji radnih mjesta (kao u nastavku), poseban pravilnik o postupku i mjerama za zaštitu dostojanstva radnika i sl..</p>
    <p>Donošenja pravilnika u nastavku, ponajviše se predlaže iz razloga preglednosti i lakšeg tumačenja, ali i zbog činjenice što su izmjene organizacije rada odnosno plaća učestalije u odnosu na izmjene ostalih odredbi koje se reguliraju pravilnikom o radu pa bi se u slučaju izmjene organizacije rada moralo mijenjati i odredbe pravilnika o radu.</p>
    <p>Poslodavac kod kojeg je formirano radničko vijeće ili djeluje sindikalni povjerenik,  mora se prije donošenja ovog pravilnika ili u slučaju izmjena/dopuna Pravilnika o radu, savjetovati s radničkim vijećem (ukoliko su radnici formirali radničko vijeće) odnosno sindikalnim povjerenikom (ukoliko je sindikat pisano obavijestio poslodavca o imenovanju sindikalnog povjerenika) na način i pod uvjetima propisanim Zakonom o radu, no nije vezan njihovim mišljenjem te Pravilnik o radu/ovaj pravilnik može donijeti unatoč njihovom protivljenju. </p>
    <strong></p>Poslodavci kod kojih nije utemeljeno radničko vijeće, niti postoji sindikalni povjerenik, pravilnik o radu donose i objavljuju samostalno.</strong> </p>
    <p>Ovaj pravilnik, kao i Pravilnik o radu ne može stupiti na snagu prije isteka roka od osam dana od dana objave.</p>
    <p>Također, pri objavi ovog pravilnika, poslodavac je dužan pridržavati se odredbi Pravilnika o načinu objave pravilnika o radu kojim se uređuje način objave pravilnika o radu.</p>
    <p>Odredbe navedenog propisa, određuju da se pravilnik o radu mora objaviti na način da bude dostupan na uvid radnicima i izložen na vidljivom mjestu u prostorijama u kojima oni redovito borave tijekom radnog dana, pri čemu se pravilnik može učiniti dostupnim radnicima i njegovom objavom na internim mrežnim stranicama, odnosno na zahtjev radnika, dostavom elektroničkom poštom.</p>
    <p>Povrh ovog pravilnika, kako bi preostala pitanja bila koja je potrebno urediti pravilnikom o radu bila uredno regulirana predlaže se donijeti i objaviti Pravilnik o radu s odredbama koje ne uključujući organizaciju rada i plaće, a koji možete vidjeti <a class="local-link" href="/contract?template=222">ovdje</a>.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o radu, Pravilnik o načinu objave pravilnika o radu.</p>
  `,

  sides: [
    {
        signature: 'Za Poslodavca',
        inputs: [{
            type: "input",
            required: true,
            placeholder: "Poslovni subjekt",
          },
          {
            type: "input",
            required: true,
            placeholder: "Ulica i kućni broj",
          },
          {
            type: "input",
            required: true,
            placeholder: "Mjesto",
          },
          {
            type: "input",
            required: true,
            placeholder: "OIB",
          },
          {
            type: "input",
            placeholder: "Zastupa",
            inSignature: true,
          },
          {
            type: "input",
            placeholder: "Funkcija",
            inSignature: true,
          }],
        suffix: ' (u daljnjem tekstu: Poslodavac),',
    }
],

headline: '​donosi sljedeći',
title: 'PRAVILNIK O ORGANIZACIJI RADA I SISTEMATIZACIJI RADNIH MJESTA KOD POSLODAVCA',

articles: [
    
    {
        title: 'OPĆE ODREDBE',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Ovim Pravilnikom uređuje se organizacija rada i sistematizacija radnih mjesta kod Poslodavca. \r\nPod organizacijom rada podrazumijeva se definiranje i hijerarhija pojedinih organizacijskih jedinica u organizacijskoj strukturi Poslodavca. \r\nPod sistematizacijom radnih mjesta podrazumijeva se definiranje naziva pojedinih radnih mjesta, odgovornosti te zadataka i standarda, kao i posebnih zahtjeva vezanih uz njihovo znanje, vještine, iskustvo i sl..',
            },
        ],
    },
        
    {
        title: 'ORGANIZACIJA RADA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Kod Poslodavca postoje sljedeće organizacijske jedinice: \r\n- Uprava (direktor), \r\n- Poslovna jedinica proizvodnja.\r\nOrganizacijska shema izlaže se u nastavku: \r\nA.    Uprava (direktor),\r\nA.1.   Voditelj poslovne jedinice proizvodnja,\r\nA.1.1. Predradnik, \r\nA.1.1.1.  Radnik u stakleničkoj proizvodnji, \r\nA.1.2. Radnik u održavanju.',
            },
        ],
    },
    {
        title: 'RUKOVOĐENJE, ODGOVORNOST, ODLUČIVANJE',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Organizacijskim jedinicama rukovodi direktor, koji utvrđuje raspored rada po radnim mjestima. \r\nDirektor  je odgovoran za uspješan rad i funkcioniranje, kao i za osiguravanje uvjeta rada koji radnicima omogućuju siguran i uspješan rad.\r\nDirektor društva odlučuje o: \r\n- prekovremenom radu, \r\n- preraspodjeli radnoga vremena, \r\n- organizaciji i načinu rada. ',
            },
        ],
    },
    {
        title: 'SISTEMATIZACIJA RADNIH MJESTA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Sistematizacija radnih mjesta iskazuje se u nastavku sa sljedećim elementima:  RADNO MJESTO, REDNI BROJ PLATNOG RAZREDA, PLAĆA (BRUTO 1; MIN.-MAX.) te stupci MOBITEL (označava radna mjesta na kojima radnici imaju pravo na mobilni uređaj i koji limit potrošnje im pripada) i AUTOMOBIL (označava radna mjesto na kojima radnici imaju pravo na korištenje službenog automobila). \r\na) RADNO MJESTO: Direktor; \r\nPLAĆA I R.BR. PLATNOG RAZREDA: od 7.000,00 kn (bruto 1) do 11.000,00 kn (bruto 1); PLATNI RAZRED BR. 1. \r\nMOBITEL: DA, mjesečni limit 600,00 kn; \r\nAUTOMOBIL: DA. \r\nb) RADNO MJESTO: Voditelj poslovne jedinice proizvodnja; \r\nPLAĆA I R.BR. PLATNOG RAZREDA: od 6.000,00 kn (bruto 1) do 8.000,00 kn (bruto 1); PLATNI RAZRED BR. 2. \r\nMOBITEL: DA, mjesečni limit 300,00 kn; \r\nAUTOMOBIL: DA., \r\nc) RADNO MJESTO: Predradnik; \r\nPLAĆA I R.BR. PLATNOG RAZREDA: od 4.000,00 kn (bruto 1) do 6.600,00 kn (bruto 1); PLATNI RAZRED BR. 3. \r\nMOBITEL: NE; \r\nAUTOMOBIL: NE.,\r\nd) RADNO MJESTO: Radnik u održavanju; \r\nPLAĆA I R.BR. PLATNOG RAZREDA: od 4.000,00 kn (bruto 1) do 6.600,00 kn (bruto 1); PLATNI RAZRED BR. 3. \r\nMOBITEL: NE; \r\nAUTOMOBIL: NE.,\r\ne) RADNO MJESTO: Radnik u stakleničkoj proizvodnji; \r\nPLAĆA I R.BR. PLATNOG RAZREDA: od 3.300,00 kn (bruto 1) do 5.000,00 kn (bruto 1); PLATNI RAZRED BR. 4. \r\nMOBITEL: NE; \r\nAUTOMOBIL: NE..',
            },
        ],
    },
    {
        title: 'OPISI RADNIH MJESTA',
        mandatory: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Nadogradnja sistematizacije radnih mjesta su OPISI RADNIH MJESTA, koji se iskazuju u obrascu za svako radno mjesto, sa sljedećim elementima: SLUŽBA / SEKTOR / ODJEL, NAZIV RADNOG MJESTA, ODGOVORAN, CILJEVI / SVRHA POSLA, KLJUČNI ZADACI I STANDARDI, ZAHTJEVI ZA ZNANJEM, VJEŠTINAMA I ISKUSTVOM, NAPOMENE, PREDLOŽIO / LA, ODOBRIO, DATUM. \r\nSvi obrasci ORM čuvaju se u sjedištu Poslodavca. ',
            },
        ],
    },
    {
        title: 'PRIJELAZNE I ZAVRŠNE ODREDBE',
        mandatory: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Ukoliko bi koja odredba ovog Pravilnika bila u suprotnosti s prisilnim propisima ili drugim aktima višeg ranga, ta činjenica neće imati utjecaj na valjanost ovog Pravilnika u cjelini, već će se umjesto sporne odredbe neposredno primijeniti odredba prisilnog propisa odnosno akta višeg ranga.',
                value: '',
            },
        ],
        value: '',
    },
    {
        title: 'PRIMJENA',
        mandatory: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Ovaj Pravilnik se primjenjuje nakon proteka roka od 8 dana od dana objave odnosno stavljanja na na oglasnu ploču Poslodavca.',
                help: "Ukoliko je kod poslodavca utemeljeno radničko vijeće odnosno kod poslodavca postoji imenovan sindikalni povjerenik (koji preuzima sva prava i obveze radničkog vijeća propisane Zakonom o radu), poslodavac je dužan savjetovati se s radničkim vijećem/sindikalnim povjerenikom prije donošenjega ovog pravilnika. Kao i pravilnik o radu, ovaj pravilnik ne može stupiti na snagu prije isteka roka od osam dana od dana objave. U pravilniku se mora naznačiti dan stupanja na snagu.",

                value: '',
            },
        ],
        value: '',
    },
            
   
    {
        mandatory: true,
        static: true,
        type: 2, // date and place
        statements: [
            {
                type: 'input',
                mandatory: true,
                parts: [
                    {
                        type: 'text',
                        content: 'U'
                    },
                    {
                        type: 'input',
                        value: '',
                        placeholder: "Upišite mjesto",
                        required: true
                    },
                    {
                        type: 'text',
                        content: ', dana'
                    },
                    {
                        type: 'date',
                        value: new Date(),
                        required: true
                    },
                    {
                        type: 'text',
                        content: 'godine.',
                    }
                ]
            },
        ]
    },
    {
        mandatory: true,
        static: true,
        type: 3,  // signatures
        statements: [],
    },
    {
        static: true,
        mandatory: false,
        type: 4, 
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Obavijest:\r\n1) Oglasna ploča Poslodavca \r\n2) Kadrovska evidencija \r\n3) Arhiva',
                
            }
        ]
    },
],
};




// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/221_pravilnik_o_org_rada.ts